// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2q1Y1","title":"InfoRow_title__2_xp8"};